import mapDegree from 'utils/degree'
import { availableDegrees } from 'utils/degrees'

enum ModalTypes {
  edit = 'edit',
  delete = 'delete',
  create = 'create'
}

enum UserTypes {
  admin = 'admin',
  reader = 'reader'
}

const classModalTitles = {
  edit: 'Editar turma',
  create: 'Adicionar turma',
  delete: 'Remover turma'
}

const classModalTitlesSimplified = {
  edit: 'Editar',
  create: 'Adicionar',
  delete: 'Remover'
}

const userModalTitles = {
  edit: 'Editar usuário',
  create: 'Adicionar usuário',
  delete: 'Remover usuário'
}

const classButtonPlaceholders = {
  edit: 'Salvar',
  create: 'Adicionar',
  delete: 'Remover'
}

const userButtonPlaceholders = {
  edit: 'Salvar',
  create: 'Adicionar',
  delete: 'Remover'
}

const userClassifications = [
  { id: 'reader', text: 'Leitor' },
  { id: 'admin', text: 'Educador(a)' }
]

const degreesItems = availableDegrees.map(degree => {
  return { id: degree, text: mapDegree(degree) }
})

export {
  ModalTypes,
  UserTypes,
  classModalTitles,
  classModalTitlesSimplified,
  userModalTitles,
  classButtonPlaceholders,
  userButtonPlaceholders,
  degreesItems,
  userClassifications
}
